import styles from './DayFilterV2.module.css';

// Generate array of 7 days centered on today
function getWeekDays() {
    const days = [];
    const today = new Date();

    // Start 3 days before today
    for (let i = -3; i <= 3; i++) {
        const date = new Date(today);
        date.setDate(today.getDate() + i);
        days.push(date);
    }

    return days;
}

// Format date to YYYY-MM-DD for comparison (using local date, not UTC)
function formatDateKey(date) {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
}

// Get day abbreviation in Spanish
function getDayAbbr(date) {
    const days = ['Dom', 'Lun', 'Mar', 'Mié', 'Jue', 'Vie', 'Sáb'];
    return days[date.getDay()];
}

// Check if date is today
function isToday(date) {
    const today = new Date();
    return formatDateKey(date) === formatDateKey(today);
}

// Check if date is in the past
function isPast(date) {
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    const compareDate = new Date(date);
    compareDate.setHours(0, 0, 0, 0);
    return compareDate < today;
}

export default function DayFilterV2({ selectedDate, onDateChange, orderCounts = {} }) {
    const weekDays = getWeekDays();

    return (
        <div className={styles['day-filter-v2']}>
            <div className={styles['day-filter-scroll']}>
                {weekDays.map(date => {
                    const dateKey = formatDateKey(date);
                    const isSelected = dateKey === selectedDate;
                    const isTodayDate = isToday(date);
                    const isPastDate = isPast(date);
                    const count = orderCounts[dateKey] || 0;

                    let className = styles['day-button-v2'];
                    if (isSelected) className += ` ${styles['selected']}`;
                    if (isTodayDate) className += ` ${styles['today']}`;
                    if (isPastDate && !isSelected) className += ` ${styles['past']}`;

                    return (
                        <button
                            key={dateKey}
                            className={className}
                            onClick={() => onDateChange(dateKey)}
                        >
                            <span className={styles['day-abbr']}>{getDayAbbr(date)}</span>
                            {isTodayDate && <span className={styles['day-today-label']}>HOY</span>}
                            <span className={styles['day-number']}>{date.getDate()}</span>
                            {count > 0 && (
                                <span className={styles['day-count']}>{count}</span>
                            )}
                        </button>
                    );
                })}
            </div>
        </div>
    );
}
